module.exports = __webpack_public_path__ + "img/fuwu.6586b52d.png";